import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { BLOG_POSTS } from "../data/content";
import { FadeUp, Stagger, StaggerItem } from "../components/Motion";
import { ArrowRight } from "lucide-react";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

const Blog = () => (
  <>
    <SEO
      title="Journal — Rudrash Private Limited"
      description="Essays, field notes and research on sustainable farming, aeroponics, and agritech from Rudrash Private Limited."
    />
    <div data-testid="page-blog">
      <PageHero
        eyebrow="Journal"
        title="Field notes & essays."
        subtitle="Dispatches from the cultivation floor — on aeroponics, mushroom genetics, saffron economics, and the future of urban farming in eastern India."
        image="https://images.unsplash.com/photo-1611250188496-e966043a0629?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="py-20 md:py-28 bg-cream">
        <div className="container mx-auto px-6 md:px-10 xl:px-16">
          <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {BLOG_POSTS.map((p) => (
              <StaggerItem key={p.slug}>
                <article data-testid={`blog-post-${p.slug}`} className="group cursor-pointer">
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]"
                      loading="lazy"
                    />
                    <span className="absolute top-4 left-4 bg-cream text-forest eyebrow px-3 py-1">
                      {p.category}
                    </span>
                  </div>
                  <div className="mt-6">
                    <span className="eyebrow text-muted-ink">{formatDate(p.date)}</span>
                    <h3 className="mt-3 font-serif text-2xl md:text-3xl text-forest leading-tight group-hover:text-saffron transition-colors">
                      {p.title}
                    </h3>
                    <p className="mt-4 text-muted-ink">{p.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-forest font-semibold text-sm tracking-wider uppercase">
                      Read more <ArrowRight size={14} />
                    </span>
                  </div>
                </article>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  </>
);

export default Blog;
